import React from 'react';
import { connect } from 'react-redux';
import styled, { ThemeProvider } from 'styled-components';
import Router from 'next/router';

import { Button, Message } from '@bijie/react-bnb';

import Layout from '../../layout';
import lightTheme from '../../themes/light';
import withSentry from '../../utils/withSentry';
import withi18n from '../../utils/withI18n';
import { getLabel } from '../../utils/i18n';
import { shouldUseAltUrl } from '../../utils/urlUtils';
import { gwGet, gwPost } from '../../actions/actionsFactory/gwRequest';
import makeOrCacheApiReq from '../../utils/apiCache';
import { checkMobile } from '../../utils/redirectToMobileSite.mjs';

import GetBaseInitialProps from '../../network/GetBaseInitialProps';
import metaInfo from '../../config/metaInfo';
import Container from '../../components/Container';
import FlexBox from '../../components/FlexBox';
import voteText from './voteText';
import ErrorPage from '../_error';

const VOTE_ID = '13';

const { brands } = metaInfo;

const BannerBox = styled(FlexBox)`
  width: 100%;
  padding: 0 4%;
  height: 580px;
  background: url(${require('./images/vote-banner.png')}) no-repeat center;
  background-size: cover;
  text-align: center;
  color: #fff;
  font-family: ${({ theme }) => theme.fontIBMRegular};
  h2 {
    font-family: ${({ theme }) => theme.fontIBMLight};
    font-weight: 300;
    font-size: 80px;
    line-height: 95px;
    letter-spacing: 0.64px;
    margin-top: 70px;
  }

  .subTitle {
    font-family: ${({ theme }) => theme.fontIBMLight};
    font-weight: 300;
    font-size: 40px;
    line-height: 40px;
    letter-spacing: 0.64px;
    margin: 40px 0 24px;
  }

  .time {
    font-weight: 500;
    font-size: 24px;
    line-height: 31px;
    > time {
      font-weight: normal;
    }
  }

  .desc {
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0.64px;
    color: #848E9C;
    margin-top: 60px;
  }

  @media screen and (max-width: 414px) {
    height: 360px;
    h2 {
      font-size: 24px;
      line-height: 28px;
      margin-top: 30px;
    }
    .subTitle {
      font-size: 18px;
      margin: 0 0 10px 0;
    }
    .time {
      font-size: 14px;
      line-height: 18px;
    }
    .desc {
      font-size: 14px;
      margin-top: 20px;
      line-height: 18px;
    }
  }
`;

const VoteBox = styled(FlexBox)`
  width: 100%;
  position: relative;
  z-index: 99;
  transform: translateY(-64px);
  @media screen and (max-width: 414px) {
    transform: translateY(0);
    .imgVs{
      margin: 0;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      img {
        width: 30px;
      }
    }
  }
`;
const VoteItem = styled(FlexBox)`
  height: 200px;
  padding: 40px 48px;
  background: #fff;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);
  border-radius: ${({ borderRadius }) => borderRadius};
  @media screen and (max-width: 414px) {
    height: 112px;
    border-radius: 0;
    padding: 12px 6px;
    justify-content: center;
    box-shadow: none;
  }
`;
const VoteItemCon = styled(FlexBox)`
   .voteName {
    font-weight: 600;
    font-size: 50px;
    line-height: 30px;
    color: #1E2126;
    margin-bottom: 34px;
    text-align: center;
   }
   button {
     min-width: 162px;
   }
   a {
     text-align: center;
   }
   @media screen and (max-width: 414px) {
    .voteName {
      font-size: 14px;
      margin-bottom: 12px;
    }
    button {
      min-width: auto;
      padding: 0 6px!important;
      font-size: 12px!important;
      height: 30px!important;
    }
  }
`;
const ChooseBox = styled.div`
   width: 120px;
   height: 120px;
   border-radius: 100%;
   padding: 8px;
   border: 2px solid #EAECEF;
   box-sizing: border-box;
   cursor: pointer;
   .inner {
     width: 100%;
     height: 100%;
     border-radius: 100%;
     text-align: center;
     background: rgba(132,142,156, 0.3)
   }
   :hover {
     border-color: #F0B90B;
     .inner {
      background: linear-gradient(90deg, #EFB80B 0%, #FBDA3C 100%);
     }
   }
   p {
     margin: 10px 0 0;
     font-size: 14px;
     line-height: 14px;
     color: #1E2126;
     font-family: ${({ theme }) => theme.fontIBMSemiBold};
   }
   @media screen and (max-width: 414px) {
    width: 70px;
    height: 70px;
    padding: 3px;
    margin: 0 4px;
    img {
      width: 24px;
    }
    p {
      font-size: 12px;
      margin: 4px 0 0;
    }
  }
`;
const PromotionA = styled.div`
  padding: 0 4%;
  strong {
    font-family: ${({ theme }) => theme.fontIBMBold};
  }
  .content {
    padding: 24px 20px;
    background: #FAFAFA;
    border-radius: 5px;
    margin-bottom: 106px;
  }
  img {
    margin: 8px 20px 0 0;
  }
  p {
    font-family: ${({ theme }) => theme.fontIBMRegular};
    font-size: 16px;
    line-height: 151%;
    color: #48515D;
    margin: 0;
  }
  @media screen and (max-width: 414px) {
    .content {margin-bottom: 30px;}
  }
`;
const PromotionB = styled.div`
  padding: 80px 4% 322px;
  background: #FAFAFA;
  text-align: center;
  font-family: ${({ theme }) => theme.fontIBMRegular};
  strong {
    font-family: ${({ theme }) => theme.fontIBMBold};
  }
  h3 {
    font-weight: 500;
    font-size: 44px;
    line-height: 60px;
    color: #212833;
    margin-bottom: 60px;
  }
  p {
    font-size: 16px;
    line-height: 150%;
    color: #48515D;
    margin-bottom: 40px;
  }

  .btns{
    text-align: center;
    margin-top: 60px;
    a, a:visited {
      display: inline-block;
      border: 1px solid #1E2126;
      border-radius: 4px;
      padding: 20px 22px;
      font-weight: 500;
      font-size: 18px;
      line-height: 23px;
      color: #212833;
      margin: 0 20px;
    }
    a:hover {
      color: #f0b90b;
      border-color: #f0b90b;
    }
  }

  @media screen and (max-width: 414px) {
    padding: 40px 4%;
    h3 {
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 30px;
    }
    .btns a {
      margin: 0 16px;
      padding: 6px 8px;
      font-size: 14px;
      border-radius: 2px;
    }
  }
`;
const RewardTable = styled.div`
  background: #fff;
  height: 400px;
  .tableBox {
    transform: translateY(-50%);
    background: #FFFFFF;
    box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.05);
    border-radius: 3px;
    padding: 75px 11.905%;
    p {
      font-weight: 500;
      font-size: 16px;
      line-height: 21px;
      color: #212833;
      margin-bottom: 24px;
    }
    table {
      width: 100%;
      td, th {
        padding: 10px 3.175%;
        :last-of-type {
          text-align: right;
        }
        :first-of-type {
          text-align: center;
          width: 16%;
        }
        :nth-of-type(2) {
          padding-left: 28%;
        }
      }
      th {
        background: rgba(234,236,239,0.3);
        font-size: 14px;
        line-height: 18px;
        color: #848E9C;
        font-family: ${({ theme }) => theme.fontIBMRegular};
        font-weight: normal;
      }
      td {
        border-bottom: 1px solid rgba(234,236,239,0.6);
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        color: #212833;
      }
      tr:nth-of-type(3) td,
      tr:nth-of-type(4) td,
      tr:nth-of-type(5) td {
        padding-top: 5px;
        padding-bottom: 5px;
      }
    }
  }
  @media screen and (max-width: 414px) {
    height: auto;
    .tableBox {
      padding: 40px 4%;
      transform: translateY(0);
      th:nth-of-type(2), td:nth-of-type(2) {
        padding-left: 8%!important;
      }
      th:first-of-type, td:first-of-type {
        width: 29%!important;
      }
    }
    .tableBox t
  }
`;
const Terms = styled.div`
  padding: 60px 4%;
  background: rgba(234,236,239,0.3);
  ul {
    list-style-type: none;
    margin-bottom: 32px;
  }
  strong {
    font-weight: 500;
    font-size: 16px;
    line-height: 21px;
    color: #48515D;
    display: inline-block;
    margin-bottom: 6px;
  }
  li, p {
    font-size: 14px;
    line-height: 22px;
    color: #848E9C;
    font-family: ${({ theme }) => theme.fontIBMRegular};
  }
  @media screen and (max-width: 414px) {
    padding: 40px 4%;
  }
`;

type Props = {
  metaData?: Object,
  url?: Object,
  i18n?: Object,
  locale?: string,
  voteId: string,
  voteInfo: Object,
  isLoggedIn: boolean,
  jexUrl: string,
};

type State = {
  isMobile: string,
}

const mapStateToProps = ({ isLoggedIn }) => ({ isLoggedIn });

export default
@withSentry
@withi18n
@connect(mapStateToProps)
class ActivityWin extends React.Component<Props, State> {
  static defaultProps = {
    metaData: {},
    url: {},
    i18n: {},
    locale: 'en',
    isLoggedIn: false,
  };

  static getInitialProps = async ctx => {
    const initProps = await GetBaseInitialProps(ctx, { withProductsData: false });
    const { id: voteId, locale } = ctx.query;
    const lang = locale === 'cn' ? 'cn' : 'en';
    const jexUrl = shouldUseAltUrl(ctx.req) ? 'https://testnet.jexzh.com/' : `https://testnet.jex.com/${lang}`;
    const promises = [];
    promises.push(
      makeOrCacheApiReq(
        `/vote/getVote.html?page=1&rows=1&voteId=${voteId}`,
        () => gwGet(`/vote/getVote.html?page=1&rows=1&voteId=${voteId}`,
          null,
          ctx.req,
          false
        )
      )
    );
    const [...responses] = await Promise.all(promises);

    const voteInfo = responses.shift();
    return {
      ...initProps,
      voteId,
      voteInfo,
      jexUrl,
    };
  };

  state = {
    isMobile: false,
  };

  componentDidMount() {
    this.setState({ isMobile: checkMobile(false, null) });
  }

 _vote = async (val) => {
   const {
     voteId, locale, isLoggedIn, i18n, voteInfo,
   } = this.props;
   if (!isLoggedIn) {
     if (this.state.isMobile) {
       window.location.href = `/m-login.html?callback=/${locale}/vote/${voteId}`;
     } else {
       Router.push(`/${locale}/login?callback=/${locale}/vote/${voteId}`);
     }
     return;
   }
   const { vote: { status } } = voteInfo.voteList[0];
   if (status !== 1) {
     const text = this._getVoteText();
     Message.fail(text.voteStatus[status]);
     return;
   }
   const result = await gwPost(`/vote/vote.html?voteId=${voteId}&optionIds=${val}`, { locale });
   const { success, msg } = result;
   if (success) {
     Message.success(getLabel('exchange-common-successful', i18n));
   } else {
     Message.fail(msg);
   }
 }

 _getOptionList = () => {
   const { voteInfo } = this.props;
   return voteInfo.voteList[0]?.optionList;
 }

 _getVoteText = () => {
   const { locale } = this.props;
   const lang = locale === 'cn' ? 'cn' : 'en';
   return voteText[lang];
 }


 render() {
   const {
     url, locale, metaData, i18n, voteId, jexUrl,
   } = this.props;
   const { isMobile } = this.state;
   if (voteId !== VOTE_ID) return <ErrorPage i18n={i18n} locale={locale} statusCode={404} />;
   const optionList = this._getOptionList();
   const text = this._getVoteText();
   const lang = locale === 'cn' ? 'cn' : 'en';
   return (
     <ThemeProvider theme={lightTheme}>
       <Layout
         url={url}
         locale={locale}
         metaData={{
           ...metaData,
           title: `${text.pageTitle} | ${brands[locale]}`,
           description: `${text.bannerDesc}`,
         }}
         isGreyBg={false}
         omitFooterTotalUpdate={true}
         isMobile={isMobile}
         omitFooter={isMobile}
       >
         <BannerBox justify="center">
           <Container>
             <h2>{text.pageTitle}</h2>
             <div className="subTitle">{text.slogon}</div>
             <div className="time">{text.tradeCompetitionPeriod}: <time>{text.voteTime}</time>.</div>
             <div className="desc">
               {text.bannerDesc}
             </div>
           </Container>
         </BannerBox>
         <VoteBox align="center">
           <VoteItem flex="1" justify="flex-end" borderRadius="0 100px 100px 0">
             <VoteItemCon align="center">
               <FlexBox justify="center" direction="column" margin={isMobile ? '0' : '0 70px 0 0'}>
                 <div className="voteName">{text[optionList[0]?.optionName]}</div>
                 <a href={`https://testnet.binancefuture.com/${lang}/futures/BTCUSDT`} target="_blank" rel="noopener noreferrer">
                   <Button type="primary" size="lg" outline={true}>{getLabel('exchange-activity-goToTrade', i18n)}</Button>
                 </a>
               </FlexBox>
               <ChooseBox onClick={() => this._vote(optionList[0]?.optionId)}>
                 <FlexBox className="inner" justify="center" align="center">
                   <div>
                     <img src={require('./images/vector.svg')} alt={text.chooseA} />
                     <p>{text.chooseA}</p>
                   </div>
                 </FlexBox>
               </ChooseBox>
             </VoteItemCon>
           </VoteItem>
           <FlexBox margin="0 54px 0" className="imgVs">
             <img src={require('./images/vs.svg')} alt="vs" />
           </FlexBox>
           <VoteItem flex="1" borderRadius="100px 0 0 100px">
             <VoteItemCon align="center">
               <ChooseBox onClick={() => this._vote(optionList[1]?.optionId)}>
                 <FlexBox className="inner" justify="center" align="center">
                   <div>
                     <img src={require('./images/vector.svg')} alt={text.chooseB} />
                     <p>{text.chooseB}</p>
                   </div>
                 </FlexBox>
               </ChooseBox>
               <FlexBox justify="center" direction="column" margin={isMobile ? '0' : '0 0 0 70px'}>
                 <div className="voteName">{text[optionList[1]?.optionName]}</div>
                 <a href={jexUrl} target="_blank" rel="noopener noreferrer">
                   <Button type="primary" size="lg" outline={true}>{getLabel('exchange-activity-goToTrade', i18n)}</Button>
                 </a>
               </FlexBox>
             </VoteItemCon>
           </VoteItem>
         </VoteBox>

         <PromotionA>
           <Container>
             <FlexBox className="content" wrap="nowrap" align="flex-start">
               <img src={require('./images/star.svg')} alt="star" />
               <p>{text.PromotionADesc}</p>
             </FlexBox>
           </Container>
         </PromotionA>

         <PromotionB>
           <Container>
             <h3>{text.PromotionBTitle}</h3>
             <p>{text.PromotionBDesc1}</p>
             <p>{text.PromotionBDesc2}</p>
             <div className="btns">
               <a href="https://testnet.binancefuture.com/en/activity" target="_blank" rel="noopener noreferrer">{text['Futures A rankings']}</a>
               <a href={`https://testnet.jex.com/${lang}/futures_market_1`} target="_blank" rel="noopener noreferrer">
                 {text['Futures B rankings']}
               </a>
             </div>
           </Container>
         </PromotionB>

         <RewardTable>
           <Container>
             <div className="tableBox">
               <p>{text.rewardTableTip}</p>
               <table>
                 <tr>
                   <th>{text.ranking}</th>
                   <th>{text['Futures A']}</th>
                   <th>{text['Futures B']}</th>
                 </tr>
                 <tr>
                   <td>{text.totalBounty}</td>
                   <td>5,000 BNB</td>
                   <td>5,000 BNB</td>
                 </tr>
                 <tr>
                   <td><img width="30" src={require('./images/rankingNo_1.svg')} alt="No.1" /></td>
                   <td>1,000 BNB</td>
                   <td>1,000 BNB</td>
                 </tr>
                 <tr>
                   <td><img width="30" src={require('./images/rankingNo_2.svg')} alt="No.2" /></td>
                   <td>500 BNB</td>
                   <td>500 BNB</td>
                 </tr>
                 <tr>
                   <td><img width="30" src={require('./images/rankingNo_3.svg')} alt="No.3" /></td>
                   <td>300 BNB</td>
                   <td>300 BNB</td>
                 </tr>
                 <tr>
                   <td>{text['4th-10th']}</td>
                   <td>{text.split} 1,200 BNB</td>
                   <td>{text.split} 1,200 BNB</td>
                 </tr>
                 <tr>
                   <td>{text['11th-20th']}</td>
                   <td>{text.split} 1,000 BNB</td>
                   <td>{text.split} 1,000 BNB</td>
                 </tr>
                 <tr>
                   <td>{text['21th-50th']}</td>
                   <td>{text.split} 1,000 BNB</td>
                   <td>{text.split} 1,000 BNB</td>
                 </tr>
               </table>
             </div>
           </Container>
         </RewardTable>

         <Terms>
           <Container>
             <strong>{text.termsAndConditions}</strong>
             <ul>
               {text.terms.map((item, index) => (<li key={index}>• {item}</li>))}
             </ul>
             <strong>{text.riskWarning}</strong>
             <p>{text.riskTip}</p>
           </Container>
         </Terms>
       </Layout>
     </ThemeProvider>
   );
 }
}
